<template>
  <div class="bg-light">
    <bottom-bar :hideBotton="zap || modo_catalogo"/>
    <div class="content" :class="{'c-zap': zap || modo_catalogo}">
      <div class="container-fluid">
        <modal-menu :menus="menus" :selected="menu" @changeMenu="(m) => this.menu = m" class="mb-3 mt-md-2" v-show="empresa.fidelidade || cupons.length"/>
        <div v-if="menu === 1">
          <fidelidade/>
        </div>
        <div v-if="menu === 2">
          <cupom componente="true" readonly="true" @cuponsDisponiveis="(c) => { this.cupons = c }"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BottomBar from "../components/BottomBar";
  import Cupom from "../components/Cupom";
  import ModalMenu from "../components/ModalMenu";
  import Icon from "../components/Icon";
  import Fidelidade from "./Fidelidade";

  export default {
    name: 'Promocoes',
    components: {Fidelidade, ModalMenu, Cupom, BottomBar, Icon },
    data() {
      return {
        token: localStorage.getItem('token'),
        cupons: [],
        menu: 1,
        menus: [
          { nome: 'Vantagens', active: true },
          { nome: 'Cupons', active: true }
        ],
      }
    },

    mounted() {
      this.$emit('buscarCupons');

      if (!this.empresa.fidelidade) {
        this.menus[0].active = false;
        this.menu = 2;
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      zap() {
        return this.$store.state.zap
      }
    }
  }
</script>

<style scoped>
</style>
